import variables from '@/styles/element-variables.scss';
export default {
  // API配置
  api: {
    // 开发环境API基础URL
    devBaseUrl: process.env.VUE_APP_BASE_API || '/api',
    // 是否启用mock数据
    useMock: process.env.NODE_ENV === 'development' && process.env.VUE_APP_USE_MOCK === 'true'
  },
  theme: variables.theme,
  /**
   * @type {boolean} true | false
   * @description Whether show the settings right-panel
   */
  showSettings: false,
  /**
   * @type {boolean} true | false
   * @description Whether need tagsView
   */
  tagsView: true,
  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,
  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: true,
  /**
   * @type {string | array} 'production' | ['production','development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production','development']
   */
  errorLog: 'production'
};